export enum HHDSMastheadAndImageType {    
    Story = 'story',
    Building = 'building',
    Location = 'location',
}